import { setConstsFromForm } from "./form"
import { drawCaves } from "./draw"
import { onDownloadButtonClicked } from "./download"

const onGenerate = () => {
  setConstsFromForm()
  drawCaves()
}

const onLoad = () => {
  onGenerate()
}

document
  .getElementById("generate")!
  .addEventListener("click", onGenerate, false)

document
  .getElementById("download")!
  .addEventListener("click", onDownloadButtonClicked, false)

window.onload = onLoad()
